import React, { FC } from 'react';
import { Choice, ChoiceItem } from '@ingka/choice';
import customerIcon from '@ingka/ssr-icon/paths/person-with-shopping-bag';
import coworkerIcon from '@ingka/ssr-icon/paths/co-worker';
import { useTranslation } from 'react-i18next';

interface TargetFormProps {
  onSelect: (id: string) => void;
  selected: string | null;
  disable?: boolean;
}

const TargetForm: FC<TargetFormProps> = ({
  onSelect,
  selected,
  disable = false,
}) => {
  const { t } = useTranslation();

  const preselectedIndex =
    selected === 'customer' ? 0 : selected === 'coworker' ? 1 : undefined;

  React.useEffect(() => {
    if (disable && selected === 'customer') {
      onSelect('coworker');
    }
  }, [disable, selected, onSelect]);

  return (
    <div className="w-full ">
      <p className="leading-normal font-bold">{t('label.targetGroup')}</p>
      <div className="demo-choice-container">
        <Choice
          className="demo-choice-flex flex flex-col md:flex-row gap-3  my-6"
          size="medium"
          onSelect={(id) => onSelect(id as string)}
          preselectedIndex={preselectedIndex}
        >
          <ChoiceItem
            id="customer"
            imageAlignment="center"
            imagePosition="leading"
            title={t('label.customer')}
            valueAlignment="center"
            ssrIcon={customerIcon}
            className={`md:w-[327px] ${
              disable ? 'opacity-50 pointer-events-none' : ''
            }`}
          />
          <ChoiceItem
            id="coworker"
            imageAlignment="center"
            imagePosition="leading"
            title={t('label.coworker')}
            valueAlignment="center"
            ssrIcon={coworkerIcon}
            className="md:w-[327px]"
          />
        </Choice>
      </div>
    </div>
  );
};

export default TargetForm;
